import { render } from "./AccountMessages.vue?vue&type=template&id=7c070818"
import script from "./AccountMessages.vue?vue&type=script&lang=js"
export * from "./AccountMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__